import axiosInstance from "../helpers/axiosInstance"

export const fetchContainerBarcodes = async (params) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/container-barcodes`,
        { params }
    )
    return res.data
}

export const generateContainerBarcodeBatch = async (data) => {
    const res = await axiosInstance.post(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/container-barcodes/generate-batch`,
        data
    )
    return res.data
}

// Opens a Blob in a new tab and revokes the object URL after a delay so the
// browser does not hold the PDF in memory for the rest of the session. Falls
// back to an anchor download when the popup is blocked.
const openPdfBlob = (pdfBlob, filename) => {
    const pdfUrl = URL.createObjectURL(pdfBlob)
    const win = window.open(pdfUrl)
    if (!win) {
        const a = document.createElement("a")
        a.href = pdfUrl
        a.download = filename
        document.body.appendChild(a)
        a.click()
        a.remove()
    }
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 60_000)
}

export const downloadContainerBarcodeLabel = async (id) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/container-barcodes/${id}/label-pdf`,
        { responseType: "blob" }
    )
    const pdfBlob = new Blob([res.data], { type: "application/pdf" })
    openPdfBlob(pdfBlob, `barcode-${id}.pdf`)
}

export const downloadContainerBarcodesBulkLabels = async (ids) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/container-barcodes/labels-pdf-bulk`,
        { params: { ids: ids.join(",") }, responseType: "blob" }
    )
    const pdfBlob = new Blob([res.data], { type: "application/pdf" })
    openPdfBlob(pdfBlob, `barcodes-${ids.length}.pdf`)
}
